/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { AUTH_ROLES } from '@/constants/roles.constant';
import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    component: () =>
      import(
        /* webpackChunkName: "orders" */ '@/modules/orders/scenes/follower-messages/follower-messages.scene.vue'
      ),
    meta: { requiresAuth: true, roles: [AUTH_ROLES.PARTNERSHIP_USER] },
    name: ROUTES.ORDERS.FOLLOWER_MESSAGES,
    path: 'orders/follower-messages'
  },
  {
    component: () =>
      import(
        /* webpackChunkName: "orders" */ '@/modules/orders/scenes/partner-orders/partner-orders.scene.vue'
      ),
    meta: {
      requiresAuth: true,
      roles: [AUTH_ROLES.PARTNERSHIP_USER]
    },
    name: ROUTES.ORDERS.ORDERS,
    path: 'orders/partner-orders'
  }
] as RouteConfig[];
